<template>
  <el-dialog title="新增收费记录" :visible.sync="visible" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="日期:" prop="feeTime">
        <el-date-picker
          v-model="data.feeTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
          style="width:100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="收费方式:" prop="chargeType">
        <el-input type="text" :maxlength="30" v-model="data.chargeType" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="金额:" prop="feeAmount">
        <el-input :maxlength="30" v-model="data.feeAmount" placeholder="请输入" clearable type="number"/>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :maxlength="30" v-model="data.remark" placeholder="请填写" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";


export default {
  name: "AddClueDialog",
  components: {
  },
  data() {
    return {
      visible: false,
      typeList: [
        {
          id: 1,
          name: "图文"
        },
        {
          id: 2,
          name: "视频"
        }
      ],
      rules: {
        feeTime: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        chargeType: [
          { required: true, message: "请输入收费方式", trigger: "change" }
        ],
        feeAmount: [
          { required: true, message: "请输入价格", trigger: "change" }
        ]
      },
      data: {
        feeTime: null,
        chargeType: null,
        feeAmount: null,
        remark: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val, val2) {
      if (val && !val2) {
        this.resetForm("addForm");
        // this.data.feeTime = null
        // this.data.chargeType = null
        // this.data.feeAmount = null
        // this.data.remark = null
      }
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
            this.$emit("success", JSON.parse(JSON.stringify(this.data)));
            this.visible = false;
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
